import LinkIcon from '@mui/icons-material/Link';
import { IconButton, InputAdornment, Stack, TextField } from '@mui/material';
import { VyDialog } from '../new-design/feedback/VyDialog';
import { Spinner } from '../design/Spinner';
import { VyTooltip } from '../new-design/VyTooltip';

type CustomerPortalDialogProps = {
  open: boolean;
  onClose: () => void;
  shareableLink: string;
  isCopied: boolean;
  isLoading: boolean;
  onCopyToClipboard: () => void;
};

export const CustomerPortalDialog: React.FC<CustomerPortalDialogProps> = ({
  open,
  onClose,
  shareableLink,
  isCopied,
  isLoading,
  onCopyToClipboard,
}) => {
  return (
    <VyDialog
      open={open}
      onClose={onClose}
      label="Customer Portal"
      cancelButtonText="Close"
      labelDescription="Anyone with the link will have access"
    >
      <div style={{ padding: 8, marginBottom: 2 }}>
        <Stack
          direction="row"
          spacing={1.5}
          sx={{
            alignItems: "center",
            padding: 1
          }}>
          {isLoading ? (
            <Stack
              direction="row"
              sx={{
                justifyContent: "center",
                width: '100%'
              }}>
              <Spinner centerPage={false} size={40} />
            </Stack>
          ) : (
            <TextField
              label="Shareable link"
              fullWidth
              disabled
              value={shareableLink}
              slotProps={{
                input: {
                  endAdornment: (
                    <InputAdornment position="end">
                      <VyTooltip tooltipContent={isCopied ? 'Link Copied' : 'Copy Link'}>
                        <IconButton onClick={onCopyToClipboard}>
                          <LinkIcon />
                        </IconButton>
                      </VyTooltip>
                    </InputAdornment>
                  ),
                }
              }}
            />
          )}
        </Stack>
      </div>
    </VyDialog>
  );
};
